<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="toggleWantClose()">
                <div class="modal-container-image" @click.stop>
                    <div class="modal-header-image">
                        Positionnez correctement votre image
                        </div>

                    <div class="modal-body-image">
                        <div id="map" style="height: 600px;"></div>
                    </div>

                    <div class="modal-footer-image">
                        <v-btn @click="getCorners()" style="float: right; right: 25px; top: 70%">
                        {{ $t('_valider_') }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

import 'leaflet-toolbar/dist/leaflet.toolbar.css'
import 'leaflet-toolbar'

import 'leaflet-distortableimage/dist/leaflet.distortableimage.css'
import 'leaflet-distortableimage'


export default {

  props: {
        center: {
            required: true,
        },
        imageURL: {
            required: true,
        },
        markerLatLng: {
            required: true,
        }
    },

    //centrer la map au meme endroit qu'avant d'ouvrir la popup
    mounted() {
    const centre = this.center
    const map = L.map('map').setView([centre.lat, centre.lng], 13)

    L.tileLayer(this.tileProviders.url, {
      attribution: this.tileProviders.attribution,
      maxZoom: 22,
      maxNativeZoom: 18,
      noWrap: true,
      tms: false,
    }).addTo(map)

    //Ajouter l'image avec des coordonnées par defaut
    const options = {
      corners: [
        {"lat" : centre.lat+0.01, "lng" :  centre.lng},
        {"lat" :centre.lat + 0.01, "lng" : centre.lng + 0.01},
        {"lat" :centre.lat, "lng" : centre.lng},
        {"lat" :centre.lat, "lng" : centre.lng + 0.01},
      ]
    }
    this.imageOverlay = L.distortableImageOverlay(this.imageURL, options).addTo(map)

},

    data() {
    return {
        imageOverlay: null,
      tileProviders: 
        {
          url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
          visible: true,
          name: "satelliteESRI",
          attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        },
    };
},
methods: {
    getCorners(){
        const corners= this.imageOverlay.getCorners()
        const mapedCorners = corners.map(corner => [corner.lat, corner.lng])
        this.$emit('close',  mapedCorners)
    }
}
}
</script>

<style scoped>
#map {
    width: 100%;
    height: 100%;
}
.modal-container-image {
    width: 90vw;
    height: 80vh;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    /* display: grid; */
    flex-direction: column;
}

.modal-header-image {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-image {
    overflow-y: auto;
    overflow-x: hidden;
    height: 88%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
}

.modal-footer-image {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    bottom: 0;
    right: 0;
}
</style>